'use client'

import { m } from 'framer-motion'
import { Mail } from 'lucide-react'

export default function ContactsHero() {
  return (
    <section className="hero-mobile-safe relative flex min-h-[100svh] items-center justify-center overflow-hidden px-4 pt-8 sm:pt-12">
      <div className="home-container relative z-10 text-center">
        <m.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-8 inline-flex items-center gap-3 rounded-full border border-purple-500/20 bg-gradient-to-r from-purple-500/10 to-pink-500/10 px-5 py-2.5 sm:mb-10"
        >
          <Mail className="h-4 w-4 text-purple-400" />
          <span className="home-meta text-purple-300">Открыты к диалогу</span>
        </m.div>

        <m.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="home-hero-title mb-8"
        >
          Обсудим ваш проект
          <br />
          <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-purple-400 bg-clip-text text-transparent">
            и маршрут роста
          </span>
        </m.h1>

        <m.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="home-hero-lead mx-auto mb-10 max-w-3xl text-gray-300 sm:mb-12"
        >
          Напишите нам удобным способом — быстро разберём задачу, предложим рабочую стратегию и
          соберём реалистичный план запуска.
        </m.p>

        <m.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.28 }}
          className="hero-stats-3 flex flex-wrap items-center justify-center gap-8 border-t border-white/5 pt-8 sm:gap-12 sm:pt-12 md:gap-24"
        >
          <div className="group cursor-default text-center">
            <div className="hero-stat-value mb-2 bg-gradient-to-b from-white to-white/50 bg-clip-text text-transparent transition-all duration-500 group-hover:to-white">
              5
            </div>
            <div className="hero-stat-label text-gray-500 transition-colors group-hover:text-[rgb(var(--accent-rgb))]">
              направлений
            </div>
          </div>
          <div className="group cursor-default text-center">
            <div className="hero-stat-value mb-2 bg-gradient-to-b from-white to-white/50 bg-clip-text text-transparent transition-all duration-500 group-hover:to-white">
              30+
            </div>
            <div className="hero-stat-label text-gray-500 transition-colors group-hover:text-[rgb(var(--accent-rgb))]">
              технологий
            </div>
          </div>
          <div className="group cursor-default text-center">
            <div className="hero-stat-value mb-2 bg-gradient-to-b from-white to-white/50 bg-clip-text text-transparent transition-all duration-500 group-hover:to-white">
              Полный цикл
            </div>
            <div className="hero-stat-label text-gray-500 transition-colors group-hover:text-[rgb(var(--accent-rgb))]">
              агентство
            </div>
          </div>
        </m.div>
      </div>

      <m.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-11 left-1/2 flex -translate-x-1/2 flex-col items-center gap-2 sm:bottom-12"
      >
        <span className="home-meta text-gray-500">Напишите нам</span>
        <m.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="h-10 w-[1px] bg-gradient-to-b from-white/50 to-transparent"
        />
      </m.div>
    </section>
  )
}
